// extracted by mini-css-extract-plugin
export default {"group":"shared_group__g91wv"};